import { FEATURES, type FeatureKey } from "./features"

export interface BlogPost {
  title: string
  slug: string
  path: string
  description: string
  date: string
  author: string
  coverImage?: string
  feature?: FeatureKey
}

// WARNING: keep this a plain data-only array literal (string fields only).
// scripts/generate-static-blog.js extracts and evals it at build time —
// computed expressions or references inside the array would break the build.
export const blogPosts: BlogPost[] = [
  {
    title: "Full Speed Ahead — Gas Optimization, Data Migration, and Verified Contracts",
    slug: "full-speed-ahead",
    path: "/assets/blog/full-speed-ahead.md",
    description: "After weeks of gas optimization, live data migration, and contract verification — the mines are upgraded and ready to run at full speed.",
    date: "2026-03-08",
    author: "Bankteller",
    coverImage: "/assets/blog/images/blue-miner.jpg",
    feature: "mining"
  },
  {
    title: "Gas, Self Serve — How Gas Top Up Unlocks Decentralization",
    slug: "gas-decentralization",
    path: "/assets/blog/gas-decentralization.md",
    description: "Why letting the community fuel the crank operator is the key to a protocol that runs itself.",
    date: "2026-03-03",
    author: "Bankteller",
    coverImage: "/assets/blog/images/gas-decentralization.jpg",
    feature: "mining"
  },
  {
    title: "The Making of WELEPHANT",
    slug: "the-making-of-welephant",
    path: "/assets/blog/the-making-of-welephant.md",
    description: "It took a lot to bring WELEPHANT to where it is now and it wasn't a straight line.",
    date: "2026-02-27",
    author: "Bankteller with special guest, Claude",
    coverImage: "/assets/blog/images/the-making-of-welephant.jpg",
    feature: "mining"
  },
  {
    title: "Platform Security Audit Complete",
    slug: "platform-security-audit",
    path: "/assets/blog/platform-security-audit.md",
    description: "Our smart contracts have completed a comprehensive security audit. Learn about the findings and our commitment to security.",
    date: "2026-01-25",
    author: "WELEPHANT Team",
    coverImage: "/assets/blog/images/platform-security-audit.jpg"
  },
  {
    title: "WELEPHANT Tokenomics Explained",
    slug: "tokenomics-explained",
    path: "/assets/blog/tokenomics-explained.md",
    description: "A deep dive into the economic model behind WELEPHANT tokens, including distribution, staking, and deflationary mechanisms.",
    date: "2026-01-20",
    author: "WELEPHANT Team",
    coverImage: "/assets/blog/images/tokenomics-explained.jpg"
  },
  {
    title: "Welcome to WELEPHANT",
    slug: "welcome-to-welephant",
    path: "/assets/blog/welcome-to-welephant.md",
    description: "Announcing the launch of WELEPHANT and what it means for open, permissionless finance on BNB Chain.",
    date: "2026-01-15",
    author: "WELEPHANT Team",
    coverImage: "/assets/blog/images/welcome-to-welephant.jpg"
  },
]

// Posts visible under the current feature flags. Consumers should use this
// instead of `blogPosts` so flagged-off features disappear from the blog.
export const visibleBlogPosts = blogPosts.filter((p) => !p.feature || FEATURES[p.feature])

export function getBlogPostBySlug(slug: string): BlogPost | undefined {
  return visibleBlogPosts.find((p) => p.slug === slug)
}

// Navigation helpers
export function getBlogPostIndex(post: BlogPost): number {
  return visibleBlogPosts.findIndex((p) => p.slug === post.slug)
}

export function getPrevBlogPost(post: BlogPost): BlogPost | null {
  const index = getBlogPostIndex(post)
  return index > 0 ? visibleBlogPosts[index - 1] : null
}

export function getNextBlogPost(post: BlogPost): BlogPost | null {
  const index = getBlogPostIndex(post)
  return index < visibleBlogPosts.length - 1 ? visibleBlogPosts[index + 1] : null
}

// Format date for display
export function formatBlogDate(dateStr: string): string {
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
